// removed by extract-text-webpack-plugin
module.exports = {"not-found":"NotFound__not-found__2xKML"};